import { forwardRef, HTMLProps, ReactNode, useMemo } from 'react';
import s from './inline-inputs.module.css';
import cn from 'classnames';
import React from 'react';

interface Props extends HTMLProps<HTMLUListElement> {
  disabled?: boolean;
  className?: string;
}

export const InlineInputs = forwardRef<HTMLUListElement, Props>((props, ref) => {
  const { children, disabled, className, ...other } = props;

  const enhancedChildren = useMemo(() => {
    const elemets: ReactNode[] = [];

    React.Children.forEach(children, (child) => {
      if (React.isValidElement(child)) {
        elemets.push(child);
      }
    });
    return elemets.map((child, index) => {
      const isFirst = index === 0;
      const isLast = index === elemets.length - 1;
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          key: index,
          // @ts-ignore
          className: cn(
            child.props.className,
            isFirst && s.first, // Добавляем класс для первого элемента
            isLast && s.last, // Добавляем класс для последнего элемента
            !isFirst && !isLast && s.middle, // Добавляем класс для элементов, которые не первые и не последние
          ),
        });
      }
    });
  }, [children]);

  return (
    <ul
      className={cn(s.feature, disabled && s.disabled, s.inlines, s.specificited, className)}
      {...other}
      ref={ref}
    >
      {enhancedChildren}
    </ul>
  );
});
